var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
      'background-image':
        'linear-gradient(0deg, rgba(30, 32, 38, 0.7),rgba(30, 32, 38, 0.7)),' +
        'url(' +
        '//' +
        this.url +
        this.download_url +
        ')',
    }),attrs:{"id":"banner"}},[(this.news.length > 0)?_c('news',{attrs:{"news":this.news}}):_vm._e()],1),_c('abstract',{attrs:{"abstract_data":{
      text: this.page.abstract,
      image: this.page.abstract_image.id,
    }}}),_c('projects',{attrs:{"projects":this.projects}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }